// import { Box, Container, Link, Grid } from "@mui/material";

// export default function Footer() {
//   const links = [
//     { href: "/termscondition", label: "Terms & Conditions" },
//     { href: "/privacypolicy", label: "Privacy Policy" },
//     { href: "/refundreturn", label: "Refund & Return Policy" },
//     { href: "/about-page", label: "About" },
//     { href: "/yubai-faq", label: "Faq" },
//     { href: "/contact", label: "Contact" },
//     { href: "/amazon-shop", label: "Amazon Market" },

//   ];

//   return (

//       <Container  maxWidth={"100%"} sx={{ bgcolor: "#374d91", }}>
//         <Grid container spacing={2} >

//           <Grid item xs={12} md={3} >
//             <Box sx={{ display: "flex",  }}>
//               <img
//                 src="/Logo/yellow-8.png"
//                 alt="Logo"
//                 style={{ width: 110}}
//               />
//             </Box>
//           </Grid>


//           <Grid
//             item
//             xs={12}
//             md={9}
//             sx={{
//               display: "flex",

//               flexWrap: { xs: "wrap", md: "nowrap" },
//               justifyContent: { xs: "flex-start", md: "flex-start" },
//               gap: 2,
//               textAlign: { xs: "left", md: "right" },

//             }}
//           >
//             {links.map((link, index) => (
//               <Link
//                 key={index}
//                 href={link.href}
//                 underline="none"
//                 sx={{
//                   fontSize: { xs: "14px", sm: "16px" },
//                   color: "#f7ef6d",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {link.label}
//               </Link>
//             ))}
//           </Grid>
//         </Grid>
//       </Container>

//   );
// }


import { Box, Container, Link, Grid } from "@mui/material";
import useTracking from "../hooks/useTracking";

export default function Footer() {

const { ref, handleClick } = useTracking("Footer");

  const links = [
    { href: "/termscondition", label: "Terms & Conditions" },
    { href: "/privacypolicy", label: "Privacy Policy" },
    { href: "/refundreturn", label: "Refund & Return Policy" },
    { href: "/about-page", label: "About" },
    { href: "/yubai-faq", label: "Faq" },
    { href: "/contact", label: "Contact" },
    { href: "/amazon-shop", label: "Amazon Market" },
  ];

  return (
    <Container
     ref={ref}
      maxWidth={"100%"}
         disableGutters
      sx={{
        bgcolor: "#374d91",
        px: "20px",    // left & right padding
        py: "20px",    // top & bottom padding
      }}
    >
      <Grid


        container
        alignItems="center"
      >
        {/* Logo */}
        <Grid item xs={12} md={3} sx={{ textAlign: { xs: "left",sm:"left", md: "left" } }}>
          <Box
            component="img"
            src="/Logo/logo yubai mainblue 1.png"
            alt="Logo"
            sx={{
              width: "92px",           // fixed width
              height: "40px",      
              display: "block",     // remove inline spacing
            }}
          />
        </Grid>

        {/* Links */}
        <Grid
          item
          xs={12}
          md={9}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "left",sm:"left", md: "left" },
            gap: 2,
            textAlign: { xs: "left", sm:"left", md: "left" },
          }}
        >
          {links.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              underline="none"
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                color: "#f7ef6d",
                whiteSpace: "nowrap",
              }}

               onClick={() => handleClick(`${link.label}_clicked`)}
            >
              {link.label}
            </Link>
          ))}
        </Grid>
      </Grid>
    </Container>

  );
}
